import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubSourcesPublishersHeaderCls: string;
			heHubSourcesPublishersPublishersItemCls: string;
		}
	},

	slug: string
}

class Publishers extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub Sources Publishers Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesPublishersHeaderCls || '', 'he_hub_sources_publishers', { animCls: 'animate__flipInX', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesPublishersPublishersItemCls + '1', 'he_hub_sources_publishers', { animCls: 'animate__zoomIn50P', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesPublishersPublishersItemCls + '2', 'he_hub_sources_publishers', { animCls: 'animate__zoomIn50P', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesPublishersPublishersItemCls + '3', 'he_hub_sources_publishers', { animCls: 'animate__zoomIn50P', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesPublishersPublishersItemCls + '4', 'he_hub_sources_publishers', { animCls: 'animate__zoomIn50P', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesPublishersPublishersItemCls + '5', 'he_hub_sources_publishers', { animCls: 'animate__zoomIn50P', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesPublishersPublishersItemCls + '6', 'he_hub_sources_publishers', { animCls: 'animate__zoomIn50P', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesPublishersPublishersItemCls + '7', 'he_hub_sources_publishers', { animCls: 'animate__zoomIn50P', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubSourcesPublishersPublishersItemCls + '8', 'he_hub_sources_publishers', { animCls: 'animate__zoomIn50P', dontClearDelay: true, once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Publishers;